/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import React from 'react'
import classNames from 'classnames'
import styles from '../style/index.css'

export function getSimpleCellItemComponent<TItem>(propertyAccessor: (item: TItem, params: any) => string) {
  return ({item, ...rest}: {item: TItem}) => (
    <div className={classNames(styles['log__cell-item'])}>
      <div className={classNames(styles['log__cell-item__value'])}>{propertyAccessor(item, rest)}</div>
    </div>
  )
}
